export const SET_FEEDBACK_AUTO_TAG_LOADING = "SET_FEEDBACK_AUTO_TAG_LOADING";
export const SET_FEEDBACK_AUTO_TAG = "SET_FEEDBACK_AUTO_TAG";
export const ADD_FEEDBACK_AUTO_TAG = "ADD_FEEDBACK_AUTO_TAG";
